// Api.js
import axios from "axios";

export const devURL = "https://dev-ori-backend.rokithc.com/";
export const prdURL = "https://prd-ori-backend.rokithc.com/";
export const localURL = "http://10.10.21.53:8080/";
// Server 변경 URL
const baseURL = devURL;

const Api = axios.create({
  baseURL: baseURL,
  headers: {
    "Content-Type": "application/json",
  },
});

// 인터셉터 설정
Api.interceptors.request.use(
  (config) => {
    if (config.data instanceof FormData) {
      delete config.headers["Content-Type"];
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

Api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status !== 404) {
      return Promise.reject(error);
    }
    return Promise.reject(error);
  }
);

export const getApi = async (url, params) => {
  try {
    const response = await Api.get(url, {
      params: params,
      headers: {},
    });
    return response.data;
  } catch (e) {
    return e;
  }
};

export const postApi = async (url, data) => {
  try {
    const response = await Api.post(url, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (e) {
    return e;
  }
};

export const putApi = async (url, data) => {
  try {
    const response = await Api.put(url, data, {
      headers: {},
    });
    return response.data;
  } catch (e) {
    return e;
  }
};

export const deleteApi = async (url) => {
  try {
    const response = await Api.delete(url, {
      headers: {},
    });
    return response.data;
  } catch (e) {
    return e;
  }
};

export default Api;
